import React, { useEffect, useState } from "react";
import "./navbar.css";
import BrochureForm from "./EnquiryForm";
import BrochureForm1 from "./brochure-form";
import { useLocation } from "react-router-dom";
import FlipperPair from "./Flipper";

function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [menuOpen, setMenuOpen] = useState(false);
  const [openMobileItem, setOpenMobileItem] = useState(null);
  const [openSubmenu, setOpenSubmenu] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleDownloadClick = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleEnquireClick = () => setShowForm(true);

  useEffect(() => {
    const handler = () => setShowModal(true);
    window.addEventListener("tims:openBrochure", handler);
    return () => window.removeEventListener("tims:openBrochure", handler);
  }, []);

  useEffect(() => {
    const handler = () => setShowForm(true);
    window.addEventListener("tims:openEnquiry", handler);
    return () => window.removeEventListener("tims:openEnquiry", handler);
  }, []);

  const logoSrc = "/logo.svg";
  const menuIcon = "/icons/menu.svg";
  const closeIcon = "/icons/close.svg";
  const chevronIcon = "/icons/chevron-down.svg";

  const WithChevron = ({ label }) => {
    const isString = typeof label === "string";
    const hasArrow = isString && /\s*>>\s*$/.test(label);
    const text = isString ? label.replace(/\s*>>\s*$/, "") : label;

    return (
      <span className="tm-chevron-wrapper">
        <span>{text}</span>
        {hasArrow ? (
          <img
            src="/images/icons/arrow_8978139.svg"
            alt=""
            width={14}
            height={14}
            className="tm-chevron-img"
          />
        ) : null}
      </span>
    );
  };

  useEffect(() => {
    const original = document.body.style.overflow;
    if (menuOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = original || "";
    return () => (document.body.style.overflow = original || "");
  }, [menuOpen]);

  useEffect(() => {
    const desktopQuery = window.matchMedia("(min-width: 1025px)");
    const closeDesktopMenu = (event) => {
      if (event.matches) {
        setMenuOpen(false);
        setOpenMobileItem(null);
        setOpenSubmenu({});
      }
    };

    closeDesktopMenu(desktopQuery);
    desktopQuery.addEventListener("change", closeDesktopMenu);

    return () => desktopQuery.removeEventListener("change", closeDesktopMenu);
  }, []);

  useEffect(() => {
    const isAboutRoute = location.pathname.startsWith("/about/");
    document.body.classList.toggle("about-route", isAboutRoute);

    return () => {
      document.body.classList.remove("about-route");
    };
  }, [location.pathname]);

  useEffect(() => {
    const dropdownItems = document.querySelectorAll(".tm-dropdown-item");
    const adjustDirection = (item) => {
      const submenu = item.querySelector(".tm-submenu-desktop");
      if (!submenu) return;

      submenu.classList.remove("tm-submenu-up", "tm-submenu-left");
      submenu.style.display = "flex";
      submenu.style.opacity = "0";

      const rect = submenu.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      submenu.style.display = "";
      submenu.style.opacity = "";

      if (rect.bottom > viewportHeight && rect.top > rect.height) {
        submenu.classList.add("tm-submenu-up");
      }
      if (rect.right > viewportWidth) {
        submenu.classList.add("tm-submenu-left");
      }
    };

    const listeners = [];
    dropdownItems.forEach((item) => {
      const listener = () => adjustDirection(item);
      item.addEventListener("mouseenter", listener);
      item.addEventListener("focusin", listener);
      listeners.push({ item, listener });
    });

    return () => {
      listeners.forEach(({ item, listener }) => {
        item.removeEventListener("mouseenter", listener);
        item.removeEventListener("focusin", listener);
      });
    };
  }, []);

  const dropdownContent = {
    Home: [],
    About: [
      { name: "Vision & Mission", link: "/vision-mission/" },
      { name: "PEOs & POs", link: "/peo-Page" }, // Not found in sitemap, kept original
      { name: "Educational Organization Policies", link: "/quality-policy/" },
      {
        name: "Messages >>",
        link: "",
        submenu: [
          { name: "Chairman's Message", link: "/chairmans-message/" },
          { name: "CEO's Message", link: "/ceos-message/" },
          { name: "Director's Message", link: "/directors-message/" },
        ],
      },
      {
        name: "Governance >>",
        link: "",
        submenu: [
          { name: "Governing Council", link: "/governing-council/" },
          { name: "Advisory Board", link: "/advisory-board/" },
          { name: "Academic Council", link: "/academic-council/" },
          { name: "College Development Committee", link: "/college-development-committee/" },
        ],
      },
      { name: " Cells And Committees", link: "/cells-and-committees/" },
      { name: "Organogram", link: "/organogram" }, // Not found in sitemap, kept original
      { name: "Our Policies", link: "/policies" }, // Not found in sitemap, kept original
    ],
    Programs: [
      { name: "Master Of Computer Applications (MCA)", link: "/program/mca-program/" },
      { name: "MCA For Working Professionals", link: "/program-mca-working-professionals/" },
      { name: "Integrated MCA", link: "/integrated-mca/" },
      { name: "Ph. D.(Computer Application)", link: "/ph-d-admission/" },
    ],
    Admissions: [
      { name: "Master Of Computer Applications (MCA)", link: "/master-of-computer-applications-mca/" },
      { name: "MCA For Working Professionals", link: "/mca-working-professional/" },
      { name: "Integrated MCA", link: "/imca/" },
      { name: "Ph. D.(Computer Application)", link: "/phd-admission/" },
      { name: "Seat Distribution", link: "/seat-distribution/" },
      { name: "AICTE Approval", link: "/aicte-approval-2/" },
      { name: "Admission Notification", link: "/admission-notification/" },
      { name: "Student Handbook", link: "/student-handbook/" },
      { name: "Code Of Conduct For Students", link: "/code-of-conduct" }, // Not found in sitemap, kept original
      { name: "Student Mentoring Program", link: "/student-mentoring-program/" },
      { name: "Anti Ragging", link: "/anti-ragging/" },
      { name: "Candidate Selected Against CAP Vacancy", link: "/canditate-aganist-cap" }, // Not found in sitemap, kept original
    ],
    "FRA-Fee Structure": [
      {
        name: "Master of Computer Applications (MCA)",
        link: "/fra-fee-structure/"
      },
      {
        name: "Working Professional MCA Fee Structure",
        link: "/working-professional-fra" // Not found in sitemap, kept original
      },
      {
        name: "Integrated MCA Fee Structure",
        link: "/integrated-mca-2/"
      },
      {
        name: "Ph.D. (Computer Applications)",
        link: "/phd" // Not found in sitemap, kept original
      }
    ],
    Academics: [
      { name: "Faculty List", link: "/faculty-list-2/" },
      { name: "Meet Our Faculty", link: "/staff/" },
      { name: "Non Teaching Staff", link: "/non-teaching-staff/" },
      { name: "Teaching Pedagogy", link: "/teaching-pedagogy/" },
      {
        name: "ERP Login",
        link: "https://portal.vmedulife.com/public/auth/#/login/timscdr-mumbai"
      },
      {
        name: "Notices >>",
        link: null,
        submenu: [
          { name: "Student Downloads", link: "/student-downloads/" },
          // {
          //   name: "Academic Depository (NAD)",
          //   link: "https://timscdrmumbai.in/wp-content/uploads/2022/05/NDML-Academic-Depository-NAD.pdf"
          // }
        ]
      }
    ],

    Facilities: [
      { name: "Infrastructure", link: "/infrastructure/" },
      { name: "DFC", link: "/drc/" },
      {
        name: "Learning Resource Center (Library) >>",
        link: null,
        submenu: [
          { name: "About Library", link: "/about-library/" },
          { name: "Infrastructure and Facilities", link: "/infrastructure-and-facilities/" },
          { name: "TIMSCDR Library Holding", link: "/timscdr-library-holding/" },
          { name: "Library Timing and Rules", link: "/library-timing-and-rules/" },
          // { name: "Library Committee", link: "/library-committee/" },
          { name: "Virtual Reading Resource", link: "/virtual-reading-resource/" },
        ],
      },
    ],
    "R&D": [
      { name: "Research Cell", link: "/research-cell/" },
      { name: "Institution Innovation Council (IIC)", link: "/institution-innovation-council-iic/" },
      {
        name: "International Conference >>",
        link: null,
        submenu: [
          { name: "International Conference (ICAIM) 2026", link: "/icaim-2026/" },
          { name: "International Conference (ICAIM) 2025", link: "/icaim-2025/" },
          { name: "International Conference (ICAIM) 2024", link: "/icaim-2024/" },
          { name: "International Conference (ICAIM) 2023", link: "/international-conferenceicaim-2023/" },
          { name: "International Conference (ICAIM) 2022", link: "/international-conferenceicaim-2022/" },
          { name: "International Conference (ICAIM) 2021", link: "/icaim-2021/" },
          { name: "International Conference (ICAIM) 2020", link: "/international-conferenceicaim-2020/" },
        ],
      },
      { name: "National Conference", link: "/national-conference-2025/" },
      { name: "IPR", link: "/ipr/" },
      {
        name: "Research Publications >>",
        link: null,
        submenu: [
          // { name: "Faculty Publications", link: "/icaim-2025" },
          // { name: "Student Publications", link: "/facilities/digital-resources" },
          { name: "TechTonics", link: "/techtonics/" },
        ],
      },
      {
        name: "Consultancy >>",
        link: null,
        submenu: [
          { name: "Consultancy / Research Projects", link: "/consultancy/" },
          { name: "Doctor Booklet", link: "/doctor-booklet/" },
        ],
      },
      { name: "RITL Excellence Lab", link: "/iot-excellence/" },
    ],
    Placements: [
      { name: "About Placement", link: "/best-mca-college-in-mumbai-for-placements-about-placement/" },
      { name: "Training Programme", link: "/training-programme/" },
      { name: "Placement Data", link: "/placement-data/" },
      { name: "Training And Placement Policy", link: "/training-and-placement-policy/" },
    ],
    IQAC: [
      {
        name: "NAAC >>",
        link: null,
        submenu: [
          {
            name: "IIQA",
            link: "/iqac/naac-iiqa", // Not found in sitemap, kept original
          },
          {
            name: "SSR",
            link: "/iqac/naac-ssr", // Not found in sitemap, kept original
          },
          {
            name: "Certificate",
            link: "/NAAC-Certificate", // Not found in sitemap, kept original
          },
        ],
      },

      {
        name: "AQAR",
        link: "/naac-aqar", // Not found in sitemap, kept original
      },

      {
        name: "Committee List",
        link: "/iqac-committee/"
      },

      {
        name: "IQAC MoM",
        link: "/iqac-mom" // Not found in sitemap, kept original
      },
    ],
    Examination: [
      { name: "Notice", link: "/notice/" },
      { name: "Exam Schedule", link: "/university-schedule/" },
      {
        name: "Result >>",
        link: "",
        submenu: [
          { name: "University Gazette", link: "/university-gazette/" },
          { name: "Result Analysis", link: "/result-analysis/" },
        ],
      },
      { name: "Convocation ", link: "/convocation/" },
    ],
    Faculty: [
      { name: "Faculty Development Program", link: "/faculty-development-programme/" },
      { name: "Short Term Training Programme", link: "/short-term-training-programme/" },
      // { name: "Achievements & Recognitions", link: "/" },
      { name: "Employee Handbook", link: "/employees-handbook/" },
    ],
    "Life@TIMSCDR": [
      {
        name: "Development Program >>",
        link: null,
        submenu: [
          { name: "Parent Interaction Programme", link: "/parent-interaction-programme/" },
          { name: "Guest Lecture", link: "/guest-lecture-sdp-pre-placement-training/" },
          { name: "SDP – Workshops & Certifications", link: "/student-development-program/" },
          { name: "Pre Placement Training", link: "/pre-placement-training/" },
        ],
      },
      {
        name: "Professional Bodies >>",
        link: null,
        submenu: [
          { name: "CSI-TIMSCDR", link: "/csi-timscdr" },
          { name: "IEEE-TIMSCDR", link: "/ieee-timscdr" },
          { name: "D-Link Academy Lab", link: "/d-link-academy-lab" },
        ],
      },
      {
        name: "Students Activity >>",
        link: null,
        submenu: [
          { name: "E‑Cell Ayan", link: "/life/e-cell-ayan" },
          { name: "Industrial Visit", link: "/life/industrial-visit" },
          { name: "Synapse", link: "/life/synapse" },
          { name: "VISTA", link: "/life/vista" },
          { name: "DLLE", link: "/life/dlle" },
          { name: "Green Club", link: "/life/green-club" },
        ],
      },
      {
        name: "Events >>",
        link: null,
        submenu: [
          { name: "Trekking", link: "/life/trekking" },
          { name: "Health & Hygiene", link: "/life/health-hygiene" },
          { name: "Clean India Campaign", link: "/life/clean-india-campaign" },
          { name: "Social Events", link: "/life/socialevents" },
          { name: "Hackathon", link: "/life/hackathon" },
        ],
      },
      {
        name: "Publications >>",
        link: null,
        submenu: [
          { name: "Magazine-Eminence", link: "/life/magazine-eminence" },
          { name: "News Letter", link: "/life/newsletter" },
        ],
      },
      { name: "Coding Club", link: "/life/coding-club" },
      // { name: "Yuvostav", link: "/life/yuvostav" },
      {
        name: "Recreational Programs >>",
        link: null,
        submenu: [
          { name: "Sports Day", link: "/life/sportsday" },
          { name: "Freshers and Farewell", link: "/life/fresher-farewell" },
          { name: "Cultural Events", link: "/life/culturalday" },
        ],
      },
      { name: "Unnat Bharat Abhiyan", link: "/life/bharatabhiyan" },
      {
        name: "Womens Development Cell >>",
        link: null,
        submenu: [
          { name: "Women Entrepreneurs Events", link: "/life/womenentepreneurs" },
          { name: "Women Health", link: "/life/womenhealth" },
          { name: "Self Defense", link: "/life/selfdefence" },
        ],
      },
      // { name: "TIMSCDR - Celebration Gallery", link: "/event-galleries" },
    ],
    Alumni: [
      { name: "Alumni Portal", link: "https://alumni.timscdrmumbai.in/" },
      { name: "Alumni Association", link: "/alumni-association/" },
      { name: "Alumni Interaction", link: "/alumni-interaction" },
      { name: "Our Distinguished Alumni", link: "/our-distinguished-alumni/" },
      { name: "Alumni Testimonials", link: "/alumni-testimonials/" },
    ],
    Contact: [
      { name: "Contact Us", link: "/contact/" },
      { name: "Student Grievance Redressal", link: "/student-grievance-redressal/" },
      {
        name: "Careers >>",
        link: "#",
        submenu: [
          { name: "Recruitment", link: "/recruitment/" },
          { name: "Employee Handbook", link: "/employees-handbook/" },
          {
            name: (
              <>
                AICTE-Faculty <br /> Position Qualification <br /> And
                Experience Eligibility{" "}
              </>
            ),
            link: "/contact/aicte-faculty", // Not found in sitemap, kept original
          },
          {
            name: (
              <>
                UoM-Faculty Position <br /> Qualification And <br /> Experience
                Eligibility <br /> CONCOL/ICC/04 Of 2012{" "}
              </>
            ),
            link: "/contact/uom", // Not found in sitemap, kept original
          },
          { name: "UoM Qualification Equivalence", link: "/contact/uom-qualification" }, // Not found in sitemap, kept original
        ],
      },
    ],
  };

  const categories = Object.keys(dropdownContent);

  return (
    <header className="tm-main-header">
      <div className="tm-navbar-wrapper">
        <div className="tm-navbar-top">
          <div className="tm-nav-logo">
            <a href="/" data-discover="true">
              <img src="/logo.svg" alt="TIMSCDR" />
            </a>
          </div>

          <div className="tm-nav-actions">
            <button onClick={handleDownloadClick} className="tm-btn tm-btn-blue">
              Brochure
            </button>
            <button className="tm-btn tm-btn-orange" onClick={handleEnquireClick}>
              Enquire
            </button>
          </div>

          <button
            className="tm-mobile-menu-btn"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            )}
          </button>
        </div>

        {/* Desktop Navbar */}
        <nav className="tm-desktop-nav">
          <ul className="tm-nav-list">
            {categories.map((cat) => (
              <li key={cat} className={`tm-nav-item ${dropdownContent[cat].length > 0 ? "tm-has-dropdown" : ""}`}>
                <a href={cat === "Home" ? "/" : "#"}>{cat}</a>
                {dropdownContent[cat].length > 0 && (
                  <div className="tm-dropdown-box">
                    {dropdownContent[cat].map((item, idx) => (
                      <div key={idx} className={item.submenu ? "tm-dropdown-item" : ""}>
                        <a href={item.link || "#"}>
                          <WithChevron label={item.name} />
                        </a>
                        {item.submenu && (
                          <div className="tm-submenu-desktop">
                            {item.submenu.map((sub, sidx) => (
                              <a key={sidx} href={sub.link}>{sub.name}</a>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/* Mobile Drawer */}
      <div className={`tm-modal-overlay tm-mobile-overlay ${menuOpen ? "tm-show" : ""}`}
        style={{ display: menuOpen ? "block" : "none" }}
        onClick={() => setMenuOpen(false)} />

      <aside className={`tm-mobile-aside ${menuOpen ? "tm-open" : ""}`}>
        <div className="tm-mobile-header">
          <img src="/logo.svg" alt="Logo" style={{ height: '40px' }} />
          <button className="tm-mobile-close" onClick={() => setMenuOpen(false)}>&times;</button>
        </div>
{/* --- ADDED MOBILE ACTION BUTTONS HERE --- */}
        <div 
          className="tm-mobile-actions" 
          style={{ display: 'flex', gap: '10px', padding: '15px', borderBottom: '1px solid #eaeaea' }}
        >
          <button 
            onClick={() => {
              handleDownloadClick();
              setMenuOpen(false); // Closes menu after clicking
            }} 
            className="tm-btn tm-btn-blue"
            style={{ flex: 1 }}
          >
            Brochure
          </button>
          <button 
            onClick={() => {
              handleEnquireClick();
              setMenuOpen(false); // Closes menu after clicking
            }} 
            className="tm-btn tm-btn-orange"
            style={{ flex: 1 }}
          >
            Enquire
          </button>
        </div>
        {/* ---------------------------------------- */}
        <div className="tm-mobile-scroll-area">
          {categories.map((cat) => (
            <div key={cat}>
              {cat === "Home" ? (
                <a href="/" className="tm-mobile-item">Home</a>
              ) : (
                <>
                  <button
                    className={`tm-mobile-item ${openMobileItem === cat ? "tm-active" : ""}`}
                    onClick={() => setOpenMobileItem(openMobileItem === cat ? null : cat)}
                  >
                    {cat} <span className="tm-arrow-icon">▼</span>
                  </button>
                  <div className={`tm-mobile-collapsible ${openMobileItem === cat ? "tm-expanded" : ""}`}>
                    {dropdownContent[cat].map((item, idx) => (
                      <div key={idx}>
                        {item.submenu ? (
                          <>
                            <button
                              className="tm-submenu-toggle"
                              onClick={() => setOpenSubmenu({ ...openSubmenu, [item.name]: !openSubmenu[item.name] })}
                            >
                              {/* Replaced {item.name} with WithChevron here */}
                              <WithChevron label={item.name} />
                            </button>
                            <div className={`tm-mobile-sub-collapsible ${openSubmenu[item.name] ? "tm-expanded" : ""}`}>
                              {item.submenu.map((sub, sidx) => (
                                <a key={sidx} href={sub.link}>{sub.name}</a>
                              ))}
                            </div>
                          </>
                        ) : (
                          <a href={item.link}>{item.name}</a>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </aside>

      {/* Forms & Modals */}
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      {showModal && (
        <div className="tm-modal-overlay" onClick={handleCloseModal}>
          <div className="tm-modal-content" onClick={(e) => e.stopPropagation()}>
            <BrochureForm1 onClose={handleCloseModal} />
          </div>
        </div>
      )}
    </header>
  );
}

export default Navbar;
